import React from 'react'
import { Menu, MenuItem, Typography } from '@mui/material'
import { Download } from '../../../icons/Download'
import { DeleteOutlinedIcon } from '../../../assets/icons'
import CheckCircle from '../../../icons/CheckCircle'
import { FileViewerMenuAction } from './FileViewerDialog'

export interface FileViewerMenuProps {
  anchorElement: HTMLElement | null
  onClose: () => void

  actions: FileViewerMenuAction[]
  onSelectAction: (action: FileViewerMenuAction) => void

  isContract?: boolean
}

export const FileViewerMenu = ({ anchorElement, onClose, actions, onSelectAction, isContract }: FileViewerMenuProps) => {
  const menuItems = [
    {
      id: FileViewerMenuAction.Download,
      title: 'Download',
      Icon: Download
    },
    {
      id: FileViewerMenuAction.MarkAsContract,
      title: `${isContract ? 'Unmark' : 'Mark'} as contract file`,
      Icon: CheckCircle
    },
    {
      id: FileViewerMenuAction.Delete,
      title: 'Delete',
      Icon: DeleteOutlinedIcon
    }
  ].filter((staticItem) => actions.includes(staticItem.id))

  return (
    <Menu open={Boolean(anchorElement)} onClose={onClose} anchorEl={anchorElement}>
      {menuItems.map(({ id, title, Icon }) => (
        <MenuItem
          onClick={(e) => {
            e.stopPropagation()
            onSelectAction(id)
            onClose()
          }}
          key={id}
        >
          <Icon fontSize="small" />
          <Typography className="text-grey-700 ml-1">{title}</Typography>
        </MenuItem>
      ))}
    </Menu>
  )
}
